const { default: Swiper } = require("swiper");
const {Navigation,  } = require("swiper/modules");

function videosSlider() {
  const heroSwiperEl = document.querySelector(".videos-slider__swiper");
  const heroSwiper = new Swiper(heroSwiperEl, {
    direction: "horizontal",
    loop: true,
    speed: 1000,
    modules: [Navigation],
    navigation: {
        nextEl: ".videos-slider__next",
        prevEl: ".videos-slider__prev",
      },
  });
}

videosSlider();

document.querySelectorAll('.videos-slider__swiper-slide').forEach((slide) => {
  const video = slide.querySelector('.videos-slider__video');
  const button = slide.querySelector('.videos-slider__button-wrapper');
  const videoWrapper = slide.closest('.videos-slider__swiper');

  if (video && button) {
    button.addEventListener('click', () => {
      if (video.tagName.toLowerCase() === 'iframe') {
      
        const src = video.getAttribute('src');
        if (!src.includes('autoplay=1')) {
          const connector = src.includes('?') ? '&' : '?';
          video.setAttribute('src', src + connector + 'autoplay=1');
        }

        videoWrapper?.classList.add('move-to-front');
        button.style.display = 'none';
      }

      if (video.tagName.toLowerCase() === 'video') {
        video.play();
        videoWrapper?.classList.add('move-to-front');
        button.style.display = 'none';

        video.addEventListener('mouseenter', showControls);
        video.addEventListener('mouseleave', hideControls);

        video.addEventListener('ended', () => {
          button.style.display = 'block';
          video.removeAttribute('controls');
          video.removeEventListener('mouseenter', showControls);
          video.removeEventListener('mouseleave', hideControls);
          videoWrapper?.classList.remove('move-to-front');
        });
      }
    });

    function showControls() {
      video.setAttribute('controls', 'true');
    }

    function hideControls() {
      video.removeAttribute('controls');
    }
  }
});

